export default __webpack_public_path__ + "static/1997-07-31_perceptual_SMPC.pdf";